import styled from "styled-components";

export const PersonalDetailsWrapper = styled.div`
  ${"" /* border-radius: 1em; */}
  ${"" /* margin: 2em 0; */}
  ${"" /* padding: 1em; */}
  box-shadow: 0 0 11px -1px rgb(229, 229, 229);
  margin-bottom: 0px;
  padding-bottom: 0px;
  margin-left: 0px;
  min-width: 286px;
  ${"" /* background-color: red; */}
  justify-content: center;
  form {
    ${"" /* background-color: gold; */}
    margin-top: 3px;
    display: flex;
    flex-wrap: wrap;
    row-gap: 10px;
    column-gap: 10px;
    justify-content: space-between;
    align-items: stretch;
  }
  .basic-form-input {
    flex: auto;
    width: 47%;
  }

  .basic-form-title {
    display: flex;
    gap: 0.5em;
    justify-content: center;
  }

  .basic-form-img {
    margin-top: 1em;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5em;
    width: 100%;
    flex-direction: column;
  }

  .basic-form-img img {
    width: 20vmax;
    max-width: 220px;
  }

  .additional-confirm {
    display: flex;
    flex-direction: row;
    margin: 0px 0px 0px 10px;
  }

  .additional-confirm > form > div > input[type="radio"] {
    align-self: center;
    height: 7px;
    padding: 6px;
    border: 1.5px solid rgb(200, 200, 200);
    border-radius: 8px;
    margin-right: 7px;
    background-color: white;
  }

  .additional-confirm > form > div > label {
    padding: 0 0rem;
    color: #6b6b6b;
    font-size: 18px;
    margin-right: 10px;
  }

  .additional-confirm > form > div > input[type="radio"]:checked {
    background-color: #cb3443;
  }

  @media only screen and (max-width: 768px) {
    border-radius: 0;
    padding: 0;
    box-shadow: none;

    .basic-form-input {
      width: 100%;
    }

    .basic-form-input-small {
      max-width: 48%;
    }
  }
  @media only screen and (min-width: 992px) {
    border-radius: 0;
    padding: 0;
    box-shadow: none;

    .basic-form-input {
      width: 100%;
    }

    .basic-form-input-small {
      max-width: 47%;
    }

    form {
      gap: 15px;
    }

    .gender {
      width: inherit;
      margin-top: -10px;
      // margin-bottom: -10px;
    }

  }

`;
